var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
import { Spinner } from '../../../Spinner';
import { AutoCompleteSelect, baseAutoCompleteA11yProps } from './Selects';
import { useInputSelect } from './useInputSelect';
var SelectContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var top = _a.top, left = _a.left, width = _a.width, colors = _a.theme.colors;
    return "\n    position: fixed;\n    top: ".concat(top, "px;\n    left: ").concat(left, "px;\n    width: ").concat(width, "px;\n    background: white;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-top: 3px solid ").concat(colors.bluesuedeshoes, ";\n    overflow: hidden;\n    z-index: 10;\n\n    box-shadow:\n      0 2px 2px 0 rgba(0, 0, 0, 0.08),\n      0 3px 1px -2px rgba(0, 0, 0, 0.08),\n      0 1px 5px 0 rgba(0, 0, 0, 0.16);\n  ");
});
var SpinnerContainer = styled(Spinner)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return "\n    background: ".concat(colors.white, ";\n    padding: ").concat(space.xs, " ").concat(space.md, ";\n    text-align: center;\n  ");
});
var InputSelect = function (_a) {
    var inputWrapperRef = _a.inputWrapperRef, variant = _a.variant, a11yDescription = _a.a11yDescription, options = _a.options, onSelect = _a.onSelect, onA11yPropsUpdate = _a.onA11yPropsUpdate, inputValue = _a.inputValue, minSearchChars = _a.minSearchChars, _b = _a.maxDisplayedOptions, maxDisplayedOptions = _b === void 0 ? 5 : _b, isLoading = _a.isLoading, customSelectionAnnouncement = _a.customSelectionAnnouncement;
    var announceAssertive = useAriaLive().announceAssertive;
    var _c = useInputSelect({
        variant: variant,
        options: options,
        inputWrapperRef: inputWrapperRef,
        inputValue: inputValue,
        minSearchChars: minSearchChars,
        maxDisplayedOptions: maxDisplayedOptions,
        isLoading: isLoading,
    }), filteredOptions = _c.filteredOptions, boundaries = _c.boundaries, showOptions = _c.showOptions, showLoading = _c.showLoading, setShowOptions = _c.setShowOptions, focusOnInput = _c.focusOnInput, isMounted = _c.isMounted;
    var resetA11yProps = useCallback(function () {
        switch (variant) {
            case 'auto-complete':
                onA11yPropsUpdate(baseAutoCompleteA11yProps);
                break;
            default:
                onA11yPropsUpdate({});
        }
    }, [variant, onA11yPropsUpdate]);
    useEffect(function () {
        resetA11yProps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant]);
    useEffect(function () {
        if (!showOptions && isMounted)
            resetA11yProps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOptions]);
    var loadingAltText = useMemo(function () {
        switch (variant) {
            case 'auto-complete':
                return "Loading ".concat(a11yDescription, " results");
            default:
                return undefined;
        }
    }, [variant, a11yDescription]);
    var selectionAnnouncement = useCallback(function (option) {
        return (customSelectionAnnouncement === null || customSelectionAnnouncement === void 0 ? void 0 : customSelectionAnnouncement(option)) || "".concat(option, " selected");
    }, [customSelectionAnnouncement]);
    var renderSelectList = function () {
        switch (variant) {
            case 'auto-complete':
                return (React.createElement(AutoCompleteSelect, { options: filteredOptions, onSelect: function (option) {
                        onSelect(option);
                        focusOnInput(inputWrapperRef);
                        announceAssertive(selectionAnnouncement(option.label));
                        setTimeout(function () { return setShowOptions(false); }, 0);
                    }, onA11yPropsUpdate: onA11yPropsUpdate }));
            default:
                return null;
        }
    };
    var renderContent = function () {
        if (showLoading) {
            return (React.createElement(SpinnerContainer, { altText: loadingAltText, size: "small", themeColor: "dark" }));
        }
        if (showOptions) {
            return renderSelectList();
        }
        return null;
    };
    if (!showOptions && !showLoading)
        return null;
    return (React.createElement(SelectContainer, __assign({}, boundaries, { "data-testid": "mui-input-select-container" }), renderContent()));
};
export { InputSelect };
var templateObject_1, templateObject_2;
//# sourceMappingURL=InputSelect.js.map